import React from 'react';
import { Link } from "react-router-dom";
import { Button } from "@material-ui/core";

const ButtonLink = ({ to, ...props }) => (
    <Link to={to}><Button {...props} /></Link>
);

export default ButtonLink;